import React, { FC } from 'react'

import { IconGravityProps } from './IconGravity.types'
import * as Styled from './styles/IconGravity.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGravity: FC<IconGravityProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGravityProps['size'],
  isResponsive = false,
}: IconGravityProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M35.852 9.191a19.018 19.018 0 1 1-23.336-.289'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 4.953v30.188' stroke='#EA1A1A' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path d='M16.766 27.906 24 35.141l7.234-7.235' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M30 6v16.254M18 6v16.254' stroke='#EA1A1A' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGravity
